import { useFormikContext } from "formik";
import React from "react";
import { Template } from "../../../../../models";
import { getCurrentTime } from "../../../../../utils";
import SwitchContainer from "../../common/SwitchContainer";

export default function AutomationToggle() {
  const { values, setFieldValue } = useFormikContext<Partial<Template>>();
  return (
    <SwitchContainer
      title="Enable Automation"
      subTitle="Auto generate articles from your profile."
      enabled={Boolean(values?.isAutoEnabled)}
      setEnabled={() => {
        setFieldValue("isAutoEnabled", !values?.isAutoEnabled);
        if (!values?.isAutoEnabled) {
          setFieldValue("autoDays", [1, 2, 3, 4, 5]);
          setFieldValue("autoTime1", getCurrentTime());
        } else {
          setFieldValue("autoDays", []);
          setFieldValue("autoTime1", null);
          setFieldValue("autoTime2", null);
        }
      }}
    />
  );
}
